export class MaintenanceActivitiesImportModel {
  counter: number = 0;
  code: number = 0;
  alterCode: string = '';
  description: string = '';

  constructor(counter: number,
    code: number,
    alterCode: string,
    description: string
  ) {
    this.counter = counter;
    this.code = code;
    this.alterCode = alterCode;
    this.description = description;
  }
}